import { Link } from "react-router-dom";

/**
 * PublicPageHeader — shared slate-navy top bar for the public SEO tool
 * pages (Jul 2026).
 *
 * Used by /free-lesson-generator and /lesson-from-resource (which also
 * catches /try via the SPA soft-redirect). Signed-in dashboard surfaces
 * use InPageTopBar/AppShell — this component is for un-shelled public
 * pages only.
 *
 * Rules
 * -----
 * - Slate-navy bar (`#1c2d3d`), full-width, no border.
 * - Atomic Edu logo mark + wordmark top-left, links to `/`.
 *   Pre-launch, ungated visitors clicking this land on the maintenance
 *   screen — acceptable; gate drops July 20.
 * - Nothing else in the header. No nav, no CTA, no user menu — those
 *   surfaces are elsewhere. Keep this bar single-purpose so it can
 *   render on any public page without collisions.
 * - Logo alt="Atomic Edu" so the cookieless tripwire can anchor on
 *   real DOM content, not a class name.
 */
export default function PublicPageHeader() {
  return (
    <header
      data-testid="public-page-header"
      className="w-full bg-[#1c2d3d] text-white"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <Link
          to="/"
          data-testid="public-page-header-home"
          className="inline-flex items-center gap-2.5 font-extrabold tracking-tight text-white hover:text-[#96ded1] transition-colors"
        >
          <img
            src="/brand/atomicedu-logo-mark.png"
            alt="Atomic Edu"
            width="36"
            height="36"
            className="h-8 w-8 sm:h-9 sm:w-9 object-contain shrink-0"
            data-testid="public-page-header-logo"
          />
          <span className="text-base sm:text-lg">Atomic Edu</span>
        </Link>
      </div>
    </header>
  );
}
